<template>
  <div class="survey-video-upload">
    <div class="video-upload-label">问卷视频：</div>
    <div class="dialogCon-descibe rfile-list-box">
      <el-upload
        ref="videoUpload"
        action="#"
        :accept="acceptTypes"
        :limit="1"
        :file-list="fileList"
        :on-exceed="handleExceed"
        :before-upload="beforeUpload"
        :http-request="uploadVideo"
        :disabled="disabled"
      >
        <div class="import-btn-tips">
          <el-button
            size="mini"
            icon="el-icon-my-import"
            style="margin-bottom: 0"
            type="importNew"
            :disabled="disabled"
            >点击上传</el-button
          >
          <div slot="tip" class="import-step-tip">
            支持 mp4 / avi / mov / wmv / flv 格式，单个视频不超过 50M
          </div>
        </div>
        <div slot="file" slot-scope="{ file }" v-show="false"></div>
      </el-upload>
      <el-progress
        v-if="uploadProgress > 0 && uploadProgress < 100"
        :percentage="uploadProgress"
        :stroke-width="6"
        style="width: 300px; margin-top: 8px"
      ></el-progress>
    </div>
    <div class="picture-box" v-if="videoFile">
      <div class="flex">
        <div class="file-name nowrap-ellipsis">
          {{ formatFileName(videoFile.fileName) }}
        </div>
        <div class="flex">
          <a @click="handlePreview" class="downFile">查看</a>
          <a @click="handleDownload" class="downFile">下载</a>
          <a v-if="!disabled" @click="clearVideo" class="downFile">删除</a>
        </div>
      </div>
    </div>
    <el-dialog
      title="视频预览"
      :visible.sync="previewVisible"
      width="700px"
      top="5vh"
    >
      <video
        :src="videoUrl"
        controls
        style="width: 100%; max-height: 70vh"
      ></video>
    </el-dialog>
  </div>
</template>

<script>
import store from "@/store";

export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      acceptTypes: ".mp4,.avi,.mov,.wmv,.flv,.mkv,.webm",
      fileList: [],
      videoUrl: "",
      videoFile: null,
      previewVisible: false,
      uploadProgress: 0,
      uploadUrl: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          try {
            const parsed = typeof val === "string" ? JSON.parse(val) : val;
            this.videoUrl = parsed.path || "";
            this.videoFile = { fileName: parsed.fileName || this.extractFileName(parsed.path), path: parsed.path };
          } catch {
            this.videoUrl = val;
            this.videoFile = { fileName: this.extractFileName(val), path: val };
          }
        } else {
          this.videoUrl = "";
          this.videoFile = null;
        }
      },
    },
  },
  methods: {
    formatFileName(filename, maxLength = 15) {
      const lastDotIndex = filename.lastIndexOf(".");
      if (lastDotIndex === -1 || filename.length <= maxLength) {
        return filename;
      }
      const name = filename.substring(0, lastDotIndex);
      const extension = filename.substring(lastDotIndex + 1);
      if (name.length > maxLength) {
        return name.substring(0, maxLength) + "..." + extension;
      }
      return filename;
    },
    extractFileName(url) {
      try {
        const segments = url.split("/");
        let last = segments[segments.length - 1];
        last = decodeURIComponent(last);
        return last || "视频文件";
      } catch {
        return "视频文件";
      }
    },
    beforeUpload(file) {
      const isVideo = file.type.startsWith("video/");
      if (!isVideo) {
        this.$message.error("请上传视频文件");
        return false;
      }
      if (file.size > 50 * 1024 * 1024) {
        this.$message.error("视频大小不能超过 50M");
        return false;
      }
      return true;
    },
    async uploadVideo(file) {
      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("fileName", file.file.name);
      this.uploadProgress = 0;
      try {
        const { data } = await this.api.postImage(this.uploadUrl, formData, {
          onUploadProgress: (e) => {
            if (e.total > 0) {
              this.uploadProgress = Math.round((e.loaded / e.total) * 100);
            }
          },
        });
        this.uploadProgress = 100;
        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.error(data.msg || "上传失败");
          return;
        }
        const path = data.data.data;
        this.videoUrl = path;
        const videoData = { fileName: file.file.name, path };
        this.videoFile = videoData;
        this.$emit("input", JSON.stringify(videoData));
        this.$message.success("视频上传成功");
      } catch (e) {
        this.uploadProgress = 0;
        this.$message.error("上传失败");
      }
    },
    handleExceed() {
      this.$message.warning("只能上传一个视频");
    },
    handlePreview() {
      this.previewVisible = true;
    },
    async handleDownload() {
      try {
        const response = await fetch(this.videoUrl);
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = this.videoFile.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      } catch {
        window.open(this.videoUrl);
      }
    },
    clearVideo() {
      this.videoUrl = "";
      this.videoFile = null;
      this.fileList = [];
      this.$emit("input", null);
      this.$refs.videoUpload && this.$refs.videoUpload.clearFiles();
    },
  },
};
</script>

<style scoped>
.survey-video-upload {
  margin: 0 20px;
  text-align: left;
}
.video-upload-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 4px;
}
.dialogCon-descibe {
  margin-bottom: 10px;
}
.import-btn-tips {
  display: flex;
  align-items: center;
}
.import-step-tip {
  font-size: 12px;
  color: #999;
  margin-left: 10px;
}
.picture-box {
  margin-top: 8px;
  margin-bottom: 8px;
}
.picture-box .flex {
  display: flex;
  align-items: center;
}
.file-name {
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #333;
}
.nowrap-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.downFile {
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
  margin-left: 20px;
  font-size: 14px;
}
</style>
